import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  API_ALERT_VARIANT,
  clearClientSession,
  resetApiAlertState,
  subscribeApiAlert,
} from "../../utils/apiAlert";

const ApiAlertModal = () => {
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();

  useEffect(() => subscribeApiAlert(setAlert), []);

  if (!alert) return null;

  const isSessionExpired = alert.variant === API_ALERT_VARIANT.SESSION_EXPIRED;
  const title = isSessionExpired ? "Session Expired" : "Error";

  const handleOk = () => {
    setAlert(null);
    resetApiAlertState();
    if (isSessionExpired) {
      clearClientSession();
      navigate("/", { replace: true });
    }
  };

  return (
    <div
      className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/50 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="api-alert-title"
    >
      <div className="w-full max-w-md overflow-hidden rounded-xl bg-white shadow-lg ring-2 ring-primary/20">
        <div className="bg-[#030253] px-6 py-2.5">
          <h2
            id="api-alert-title"
            className="mb-0 text-center font-UbuntuBold !text-base !text-white"
          >
            {title}
          </h2>
        </div>
        <div className="px-6 pb-4 pt-4 text-center font-UbuntuRegular">
          <p className="mb-4 text-sm text-gray-800">{alert.message}</p>
          <button
            type="button"
            className="btn btn-danger min-w-32 rounded-full px-8 py-2 text-white"
            onClick={handleOk}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiAlertModal;
